// extracted by mini-css-extract-plugin
export default {"wrapper":"oddsCalculator_wrapper__HwdBX"};